import { render, staticRenderFns } from "./Espresso.vue?vue&type=template&id=6806d79c&scoped=true"
import script from "./Espresso.vue?vue&type=script&lang=js"
export * from "./Espresso.vue?vue&type=script&lang=js"
import style0 from "./Espresso.vue?vue&type=style&index=0&id=6806d79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806d79c",
  null
  
)

export default component.exports